import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { useRealmApp } from '../RealmApp';

const usePriceLists = () => {
  const app = useRealmApp();
  const { priceLists, loading } = useAllPriceLists(app.currentUser.id);
  return {
    loading,
    priceLists,
  };
};

export default usePriceLists;

function useAllPriceLists(ownerId) {
  //
  const { data, loading, error } = useQuery(
    gql`
      query getPriceLists($ownerId: String!) {
        priceLists(query: { owner_id: $ownerId }, limit: 0) {
          _id
          name
          items {
            _id
            itemId
            price
          }
          updateDatetime
          creationDatetime
        }
      }
    `,
    { variables: { ownerId } }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const priceLists = data?.priceLists ?? [];
  return { priceLists, loading };
}
